import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { SimulationProblem } from './components/sections/SimulationProblem';
import { Comparison } from './components/sections/Comparison';
import { PainPoints } from './components/sections/PainPoints';
import { Roadmap } from './components/sections/Roadmap';
import { Volumes } from './components/sections/Volumes';
import { Tools } from './components/sections/Tools';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full overflow-x-hidden bg-navy font-sans" data-id="element-0" data-mp="3mlavl1vse5rc">
      <MetaPixel data-id="element-1" data-mp="3mjpyp5m02aqb" />
      <Hero data-id="element-2" data-mp="3mj6lu3b7icj5" />
      <main data-id="element-3" data-mp="3rcj7q5oi4587">
        <SimulationProblem data-id="element-4" data-mp="3rbrcwx2qabiz" />
        <Comparison data-id="element-5" data-mp="3rdkkqfp2v1sk" />
        <PainPoints data-id="element-6" data-mp="3recdzjv7cnfo" />
        <Roadmap data-id="element-7" data-mp="5yi8qe3h5da" />
        <Volumes data-id="element-8" data-mp="6hovayao7c0" />
        <Tools data-id="element-9" data-mp="4wx1t3d72hu" />
        <Bonuses data-id="element-10" data-mp="5gfdawxfswe" />
        <Offer data-id="element-11" data-mp="82kl3wchwbg" />
        <Guarantee data-id="element-12" data-mp="2zl3a7gleoy37" />
        <Testimonials data-id="element-13" data-mp="2zllen0i82im7" />
        <Author data-id="element-14" data-mp="2zm4v0cs84yy4" />
        <Faq data-id="element-15" data-mp="2zmo5x9jgin2n" />
        <FinalCta data-id="element-16" data-mp="2zn6b4vo3kbmp" />
      </main>
      <Footer data-id="element-17" data-mp="33mf0loc3tncg" />
      <FloatingCta data-id="element-18" data-mp="33lwywc6oagx5" />
      <PurchasePopup data-id="element-19" data-mp="33nggq77z9011" />
    </div>;
}